import axios from 'axios';
import {  notifyError,refreshLocalStorage } from './helper';
import { LOGIN_LINK, APP_URL } from './constants/constants';

const client = () => {
  // Create an instance of Axios
  const api = axios.create({
    baseURL: APP_URL, // Replace with your API base URL  
  });

  // Add a request interceptor
  api.interceptors.request.use(async config => {
    const token = localStorage.getItem('token');
    if (config.headers) {
      config.headers.Authorization = token;
      if(config.headers.Action === 'upload'){
        config.headers['Content-Type'] = 'multipart/form-data';
      } else {
        config.headers['Content-Type'] = 'application/json';
      }
    }
    return config;
  });
  // Add a response interceptor to handle 401 and 403 errors
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        const status = error.response.status;

        if (status === 401) {
          console.log("Unauthorized. Redirecting to login...");
          //toast.dismiss();
          if(window.location.pathname === '/login'){
            notifyError('Your login credentials are not valid');
          } else {
            notifyError('Your login has expired. Redirecting you to login page');
            setTimeout(function(){
              window.location.href = LOGIN_LINK;
            },2000);
          }          
          refreshLocalStorage();
          // Redirect to login (you could also update state or route here)
          } else if (status === 403) {
            console.log("Forbidden. You don't have permission.");
            notifyError('You are not authorized to perform this action');
            //alert("You are not authorized to perform this action");
          } else if (status === 500) {
            notifyError('Server is not correctly behaving right now. Please try later.');
            //alert("Server is not correctly behaving right now. Please try later.");
          } else if (status === 503) {
            notifyError('Server is not online right now to serve the request. Please try later.');
            //alert("Server is not online right now to serve the request. Please try later.");
          }
        }
        return Promise.reject(error);
      }
    );
  return api;
} 
export default client;